// If you change these, update example_configs/config-ui.yaml and the helm chart
export const CUSTOM_TITLE_LIMIT = 250;
export const CUSTOM_MESSAGE_LIMIT = 10000;
export const CUSTOM_BANNER_TEXT_LIMIT = 2000;
